import {
  Component,
  DestroyRef,
  inject,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { BillState, getBillStateLabel } from 'src/app/_types/billing.types';
import { ComboboxComponent } from 'src/app/shared/components/combobox/combobox.component';

import { BillStatusBadgeComponent } from '../bill-status-badge/bill-status-badge.component';

/** Bill states offered by the history status filter, in display order. */
const FILTER_STATES: BillState[] = ['SENT', 'REJECTED'];

@Component({
  selector: 'app-bill-state-combobox',
  standalone: true,
  imports: [ComboboxComponent, BillStatusBadgeComponent],
  template: `
    <ng-template #stateTpl let-state>
      <app-bill-status-badge [status]="state" />
    </ng-template>

    <app-combobox
      [control]="control()"
      [items]="states()"
      [itemTemplate]="stateTpl"
      [(searchValue)]="searchValue"
      [selectOnly]="true"
      [noBorder]="noBorder()"
      [enableUnselect]="enableUnselect()"
      [placeholder]="placeholder()"
      (searchChange)="onSearchChange($event)"
    />
  `,
})
export class BillStateComboboxComponent implements OnInit {
  control = input.required<FormControl<BillState | null>>();

  noBorder = input(false);

  enableUnselect = input(false);

  placeholder = input('');

  /** States offered by the dropdown; defaults to the history filter's pair. */
  states = input<BillState[]>(FILTER_STATES);

  searchValue = signal('');

  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    const ctrl = this.control();
    if (ctrl.value) {
      this.searchValue.set(getBillStateLabel(ctrl.value));
    }

    ctrl.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((val) => {
        this.searchValue.set(val ? getBillStateLabel(val) : '');
      });
  }

  onSearchChange(q: string): void {
    if (!q) this.control().setValue(null);
  }
}
